import MicroFrontendLoaderV1 from './MicroFrontendLoaderV1';
import { MicroFrontendLoaderProps } from './types';

const MicroFrontendLoader = (props: MicroFrontendLoaderProps) => {
    return <MicroFrontendLoaderV1 {...props} />;
};

export default MicroFrontendLoader;